import CustomButton from "../custom-button";

const Thumbnail = ({ name, image, onClickThumbnail }) => (
  <div className="thumbnail">
    <div className="name-container">
      <span>{name}</span>
    </div>
    <div className="image-container" onClick={onClickThumbnail}>
      <CustomButton
        size="sm"
        additionalClasses="enlarge-button"
        text="Ver en tamaño completo"
        animation="fade-in"
        icon="expand"
      />
      <img src={image} alt={`thumbnail-${name}`} />
    </div>
  </div>
);

export default Thumbnail;
